<section class="shared-widget-container">
  <header class="shared-widget-container-heading">
    <ng-content select="[title]" class="title"></ng-content>
  </header>

  <div class="shared-widget-container-block">
    <ng-content select="[block]"></ng-content>
  </div>

  <footer class="shared-widget-container-actions">
    <ng-content select="[actions]"></ng-content>
  </footer>
</section>
